import SectionHeader from 'components/SectionHeader';

export default function HeroSection() {
  return (
    <section className="pt-(--vertical-spacing)">
      <div className="container">
        <SectionHeader
          title="Motion data for insight, not just animation"
          description="Structured, high-fidelity human motion data for training, analysis, and simulation across physical and digital systems."
          headingLevel="h1"
        />
      </div>
    </section>
  );
}
